import React from "react"
import cx from "classnames"
import styles from "./styles.module.scss"
import Img from "gatsby-image"

interface Props {
	file: any
	align: string
	alt: string
	mode: string
}

const BlockImage:React.FC<Props> = ({file, alt, align, mode}) => {
	const alignStyle = align === "right" ? styles.ImageRight : styles.ImageLeft
	const modeStyle = mode === "portrait" ? styles.ImagePortrait : null
	if (file && file.childImageSharp && file.childImageSharp.fluid) {
	
	return (
		<div className={cx(styles.ImageContainer)}>
		<Img
			fluid={file.childImageSharp.fluid}
			alt={alt}
			className={cx(alignStyle, modeStyle, styles.Image)}
		/>
		</div>
	)
	}

	return null
}

export default BlockImage